import { Grid2, Typography } from '@mui/material';
import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Icon from '@components/Icon/Icon';
import RoundedButton from '@components/RoundedButton/index';
import TextInputBox from '@components/TextInputBox';

import { useUpdateDocument } from '@hooks/api/document';
import { useSession } from '@hooks/useSession';

import type { DocumentModel } from 'generated/types';

const messages = defineMessages({
  save: {
    id: 'GLOBAL.save',
    defaultMessage: 'Save',
  },
});

function DocumentName({ doc }: { doc: DocumentModel }) {
  const { formatMessage } = useIntl();
  const {
    state: { isVitall },
  } = useSession();
  const [updateDocument, updateDocumentLoading] = useUpdateDocument();

  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [document, setDocument] = useState<{ name: string; id: string }>({
    name: '',
    id: '',
  });

  const handleStartEditing = (doc: DocumentModel) => {
    setIsEditing(true);
    setDocument({ name: doc.name ?? '', id: doc.document_id });
  };
  const handleCancelEditing = () => {
    setIsEditing(false);
    setDocument({ id: '', name: '' });
  };
  const handleFinishEditing = async () => {
    await updateDocument({
      input: {
        document_id: document.id,
        document: {
          name: document.name,
        },
      },
    });
    setIsEditing(false);
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setDocument((prev) => ({ ...prev, name: value }));
  };

  const { document_id, name } = doc;

  return (
    <Grid2 alignItems="center" container direction="row">
      {isEditing && document_id === document.id ? (
        <>
          <TextInputBox onChange={handleChange} value={document.name} />
          <Grid2 mx={2}>
            <Icon
              clickable
              color="text.secondary"
              name="xmark"
              onClick={handleCancelEditing}
              size="lg"
              type="fas"
            />
          </Grid2>
          <Grid2>
            <RoundedButton
              disabled={updateDocumentLoading}
              fontSize={14}
              height="30px"
              onClick={handleFinishEditing}
              width="80px"
            >
              {formatMessage(messages.save)}
            </RoundedButton>
          </Grid2>
        </>
      ) : (
        <Grid2>
          <Typography>{name}</Typography>
          {isVitall && (
            <Icon
              clickable
              color="text.secondary"
              name="pencil"
              onClick={() => handleStartEditing(doc)}
              size="lg"
              type="fas"
            />
          )}
        </Grid2>
      )}
    </Grid2>
  );
}

export default DocumentName;
